<template>
  <v-container class="py-0 px-5">
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <data-selector
          v-model="extension.plane_id"
          field-name="reg_num"
          source-type="custom"
          :custom-source="planes"
        />
      </v-col>
      <v-col>
        <data-selector
          v-model="extension.payer_organization_id"
          field-name="maintenance_organization"
          label="maintenance_organization"
          source-type="maintenance-organizations"
          rules=""
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'EditPlaneMaintenance',
    props: {
      extension: Object,
      planes: {
        type: Array,
        default: () => ([]),
      },
    },
  }
</script>
